if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Enfin Libre 10 sept. 2026 (A) : tiroir optimiste — s'ouvre tout de suite avec la ligne construite depuis la page ;
        // renderContents() remplace ensuite tout le contenu par le rendu serveur (~0,8 s), hideOptimistic() en cas d'erreur.
        this.optimistic = false;
        const idInputOpt = this.form.querySelector('[name=id]');
        if (this.cart && this.cart.tagName === 'CART-DRAWER' && typeof this.cart.showOptimistic === 'function' && !(idInputOpt && idInputOpt.dataset.skipCart === 'true')) {
          try { this.cart.showOptimistic(this.getOptimisticLine()); this.optimistic = true; } catch (e) { this.optimistic = false; }
        }


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
        // Enfin Libre 10 sept. 2026 (B) : la pré-vérification /cart.js ne sert qu'à l'upsell → sautée si aucun produit d'upsell (−140 ms).
        (this.upsellVariantId
          ? fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((cartState) => {
                if (cartState.item_count === 0 && this.upsellVariantId) {
                  return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
                }
              })
          : Promise.resolve())
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (this.optimistic && this.cart && this.cart.hideOptimistic) this.cart.hideOptimistic(true);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            if (this.optimistic && this.cart && this.cart.hideOptimistic) this.cart.hideOptimistic(true);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      getOptimisticLine() {
        const root = this.closest('.shopify-section') || document;
        const q = (sel, scope) => (scope || root).querySelector(sel) || document.querySelector(sel);
        const titleEl = q('.product__title h1') || q('h1.product__title') || q('.product__title') || q('h1');
        const checked = [...(root.querySelectorAll('variant-radios input:checked, variant-selects select') || [])];
        const variant = checked.length ? checked.map((e) => e.value).join(' / ') : [...document.querySelectorAll('variant-radios input:checked')].map((e) => e.value).join(' / ');
        const priceEl = q('.price .price-item--sale:not(:empty), .price .price-item--regular, .price__regular .price-item, .price-item');
        const img = q('.product__media-item.is-active img, .product__media img, media-gallery img');
        const qty = this.form.querySelector('[name=quantity]') || q('quantity-input input');
        return {
          title: (titleEl ? titleEl.textContent : (document.title.split('–')[0] || '')).replace(/\s+/g, ' ').trim(),
          variant: variant,
          price: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '',
          image: img ? (img.currentSrc || img.src) : '',
          quantity: qty ? qty.value : '1',
        };
      }

            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
